
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.083 7.5c.026-.67.1-1.353.225-2.042.092-.513.139-.77.297-.946.158-.176.55-.3 1.332-.55C5.862 3.35 7.49 1.667 9.998 1.667c2.51 0 4.14 1.682 6.064 2.296.783.249 1.174.373 1.332.55.159.175.205.432.298.945.124.69.2 1.372.225 2.042m-1.713 6.667c-1.1 1.685-2.723 3.03-4.859 3.848-.555.212-.833.318-1.344.318-.51 0-.788-.106-1.344-.318-2.136-.817-3.76-2.163-4.86-3.848","stroke":"#141B34","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M7.083 10l.834.834m0 0l.833.833m-.833-.833L8.75 10m-.833.834l-.834.833M2.917 10l.833.834m0 0l.833.833m-.833-.833L4.583 10m-.833.834l-.833.833M11.25 10l.833.834m0 0l.834.833m-.834-.833l.834-.834m-.834.834l-.833.833M15.416 10l.834.834m0 0l.833.833m-.833-.833l.833-.834m-.833.834l-.834.833","stroke":"#141B34","stroke-width":"1.5","stroke-linecap":"round"}})])
          )
        }
      }
    